import { useState } from 'react';
import EmailSentView from './EmailSentView';
import FormView from './FormView';

const ForgotPassword = () => {
  const [emailSent, setEmailSent] = useState(false);

  return <div className='w-1/2'>{emailSent ? <EmailSentView /> : <FormView setEmailSent={setEmailSent} />}</div>;
};

export default ForgotPassword;
